export default {
  "name": "NCTabPane",
  "column": 1,
  "canAppend": true,
  "type": 1,
  "path": "LowCodeComponents.NCTabs.TabPane",
  "label": "页签",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "key": {
        "title": "activeKey",
        "description": "activeKey",
        "type": "string"
      },
      "tab": {
        "title": "tab",
        "description": "选项卡头显示文字",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}